


import React, { useEffect, useState } from 'react';
import { toast, ToastContainer } from 'react-toastify'; // Importing toastify
import 'react-toastify/dist/ReactToastify.css'; // Importing toastify styles
import Navbar from './Navbar'; // Assuming Navbar is a separate component
import ManagerHeader from './ManagerHeader';

const Notifications = () => {
  const [notifications, setNotifications] = useState([]); // State to store all notifications
  const [currentPage, setCurrentPage] = useState(1); // Current page number
  const [loading, setLoading] = useState(true); // Loading state
  const notificationsPerPage = 7; // Notifications per page

  // Function to fetch notifications
  const fetchNotifications = async () => {
    const managerID = localStorage.getItem('managerID');
    
    if (!managerID) {
      toast.error('Manager ID not found'); // Show error if manager ID is not foundsss
      setLoading(false);
      return;
    }

    const apiUrl = `https://server-side-influencer.onrender.com/manager/notifications/${managerID}`;

    try {
      const response = await fetch(apiUrl);
      const data = await response.json();

      if (data.success) {
        setNotifications(data.notifications);
      } else {
        toast.error('Failed to load notifications'); // Show error as toast
      }
    } catch (error) {
      toast.error(`Error: ${error.message || 'An error occurred while fetching notifications'}`); // Show detailed error message as toast
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Fetch notifications when component mounts
    fetchNotifications();
  }, []); // Only run once when component mounts

  // Function to handle clearing all notifications
  const handleClearAllNotifications = async () => {
    const managerID = localStorage.getItem('managerID');
    
    if (!managerID) {
      toast.error('Manager ID not found'); // Show error if manager ID is not found
      return;
    }

    // Clear notifications directly from state (client-side)
    setNotifications([]);  // Immediately clear the notifications from the UI

    // Send API request to clear notifications on the server
    const apiUrl = `https://server-side-influencer.onrender.com/manager/clearallnotifications/${managerID}`;

    try {
      const response = await fetch(apiUrl, {
        method: 'DELETE', // Use DELETE method
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const data = await response.json();

      if (data.success) {
        toast.success(data.message); // Show success message from API response as toast
        // Refetch notifications after clearing them
        fetchNotifications();
      } else {
        toast.error(data.message || 'Failed to clear notifications'); // Show error message from API response
      }
    } catch (error) {
      toast.error(`Error: ${error.message || 'An error occurred while clearing notifications'}`); // Show detailed error message from catch block
    }
  };

  // Function to get the current page's notifications
  const currentNotifications = notifications.slice(
    (currentPage - 1) * notificationsPerPage,
    currentPage * notificationsPerPage
  );

  // Function to handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Calculate total number of pages
  const totalPages = Math.ceil(notifications.length / notificationsPerPage);

  return (
    // <div className="flex">
    //   {/* Sidebar/Navbar */}
    //   <Navbar />

    <div className="flex h-screen mb-0">
    <div className="text-white fixed top-0 left-0 bottom-0 z-10">
      <Navbar />
    </div>

      {/* Main Content Area */}
      <div className="ml-14 w-screen max-sm:ml-0 h-screen p-5 ">
        {/* Brand Header */}
        <ManagerHeader page="Notifications" />

        {/* Heading */}
        <div className="text-center mb-8 mt-10">
          <h1 className="text-xl font-bold text-black uppercase tracking-wider py-4 ml-9">
            Check Your Notifications
          </h1>
        </div>

        {/* Clear All Button */}
        {notifications.length > 0 && (
          <div className="text-right mb-4">
            <button
          onClick={handleClearAllNotifications}
          className="text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center transition"
        >
          Clear All
        </button>
          </div>
        )}

        {/* Notification Cards */}
        <div className="space-y-6 ">
          {loading ? (
            <p>Loading notifications...</p> // Show loading text while fetching
          ) : currentNotifications.length > 0 ? (
            currentNotifications.map((notification) => (
              <div key={notification.id} className="bg-white rounded-lg p-5 shadow-lg flex flex-col gap-4 ">
                <div className="flex items-center gap-4">
                  {/* Display Profile Image */}
                  <img 
                    src={notification.brandLogo} 
                    alt="Brand Logo" 
                    className="w-8 h-8 rounded-full " 
                  />
                  {/* Shop Name */}
                  <span className="font-semibold text-lg ">{notification.message}</span>
                </div>
              
                <div className="flex justify-between items-center text-sm text-gray-600">
                  {/* Additional info like timestamp can be added here */}
                </div>
              </div>
            ))
          ) : (
            <p>No notifications available.</p> // Display a message if no notifications are available
          )}
        </div>

        {/* Pagination Controls */}
        {totalPages > 1 && (
          <div className="flex justify-center space-x-4 mt-6">
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className="bg-gray-500 text-white px-4 py-2 rounded-md disabled:opacity-50"
            >
              Previous
            </button>
            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="bg-gray-500 text-white px-4 py-2 rounded-md disabled:opacity-50"
            >
              Next
            </button>
          </div>
        )}
      </div>

      {/* Toast Container for displaying messages */}
      <ToastContainer position="top-right" autoClose={5000} />
    </div>
  );
};

export default Notifications;
